import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableColumn, TableHeader, TableRow } from '@nextui-org/table';
import axios from 'axios';
import { Button, Input, Modal, Pagination, Spin, notification } from 'antd';
import dayjs from 'dayjs';
import { EditOutlined, MailOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

const ClientSearcher = ({ setActiveTabKey, setSelectedDate }) => {
    const [clientsFromDb, setClientsFromDb] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [hasMoreResults, setHasMoreResults] = useState(false);
    const [emailToSend, setEmailToSend] = useState('');
    const [studentToSendEmail, setStudentToSendEmail] = useState();
    const [isModalMailVisible, setIsModalMailVisible] = useState(false);


    const [api, contextHolder] = notification.useNotification();


    const openNotification = (message, description, placement) => {
        api[message.type]({
            message: message.content,
            description,
            placement,
        });
    };

    const closeMailModal = () => {
        setIsModalMailVisible(false);
        setEmailToSend('');
    };


    const handleNewMail = (e) => {
        setEmailToSend(e.target.value)
    }


    const handleSendEmail = async () => {
        const emailDto = {
            to: emailToSend,
            name: studentToSendEmail.name,
            course: studentToSendEmail.course?.title,
            date: formatDate(studentToSendEmail.lessons[0].lessonDate),
            startHs: studentToSendEmail.lessons[0].startHour,
            finishHs: studentToSendEmail.lessons[0].finishHour,
            confirmationText: studentToSendEmail.course.confirmationText,
            quantity: studentToSendEmail.vouchers.seatsQty.toString()
        }


        try {
            const url = process.env.REACT_APP_URI + `/v1/email`
            await axios.post(url, emailDto)
            openNotification(
                { type: "success", content: "Email Enviado" },
                "El email se ha reenviado satisfactoriamente.",
                "bottomRight"
            );
            setEmailToSend('');
            setTimeout(() => setIsModalMailVisible(false), 1700);
        } catch (error) {
            openNotification(
                { type: "error", content: "Fallo envio email" },
                "El email no se ha podido enviar correctamente.",
                "bottomRight"
            );
            setTimeout(() => setIsModalMailVisible(false), 1700);
        }
        setEmailToSend('');

    }


    const getClientsFromDb = async (searchTerm = '', page = 1) => {
        try {
            setLoading(true);
            const params = new URLSearchParams({
                hasLessons: 'false', // Buscamos todos los clientes, tengan o no lessons
                limit: (pageSize + 1).toString(), // Pedimos uno más para saber si hay más resultados
                skip: ((page - 1) * pageSize).toString(),
            });

            if (searchTerm && searchTerm.trim()) {
                params.append('search', searchTerm.trim());
            }

            const clientsRequest = await axios.get(
                `${process.env.REACT_APP_URI}/v1/clients/withVouchers?${params.toString()}`
            );

            const results = clientsRequest.data || [];
            // Si hay más resultados que el pageSize, hay más páginas
            const hasMore = results.length > pageSize;
            const clientsToShow = hasMore ? results.slice(0, pageSize) : results;

            setClientsFromDb(clientsToShow);
            setHasMoreResults(hasMore);
            setLoading(false);
        } catch (error) {
            console.log("error fetching", error);
            setLoading(false);
        }
    };

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            getClientsFromDb(searchTerm, currentPage);
        }, searchTerm ? 500 : 0); // Debounce de 500ms solo si hay búsqueda

        return () => clearTimeout(timeoutId);
    }, [searchTerm, currentPage]);

    const headersToRender = [
        {
            title: 'Nombre',
            accessor: 'name',
        },
        {
            title: 'Email',
            accessor: 'email',
        },
        {
            title: 'Telefono',
            accessor: 'phone',
        },
        {
            title: 'Asientos',
            accessor: 'seats',
        },
        {
            title: 'Origen',
            accessor: 'source',
        },
        {
            title: 'Localizador',
            accessor: 'localizador',
        },
        {
            title: 'Código',
            accessor: 'code',
        },
        {
            title: 'Curso',
            accessor: 'course',
        },
        {
            title: 'Horario',
            accessor: 'time',
        },
        {
            title: '',
            accessor: 'buttons',
        },

    ];


    const handleClicMailIcon = (studentToSendEmailInformation) => {
        setStudentToSendEmail(studentToSendEmailInformation);
        setIsModalMailVisible(true);
    }


    // Ya no necesitamos filtrar localmente, el backend lo hace
    useEffect(() => {
        setSearchResults(clientsFromDb);
    }, [clientsFromDb]);


    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Resetear a la primera página cuando se busca
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleClickLessonTime = (dateWanted) => {
        setSelectedDate(dateWanted);
        setActiveTabKey('2');
        localStorage.setItem('activeTabKey', '2')
    }

    // Ya no necesitamos hacer slice porque la paginación se hace en el backend
    const currentClients = searchResults;

    const items = currentClients.map(item => {
        const voucher = item.vouchers ? item.vouchers : null;
        const seats = voucher ? voucher.seatsQty : '';
        const source = voucher ? voucher.source : '';
        const tracker = voucher ? voucher.tracker : '';
        const code = voucher ? voucher.code : '';

        return {
            key: item.id,
            name: <b>{item.name}</b>,
            email: <span>{item.email}</span>,
            phone: <span>{item.phone}</span>,
            seats: <span>{seats}</span>,
            source: <span>{source}</span>,
            localizador: <span>{tracker}</span>,
            code: <span>{code}</span>,
            course: <span>{item.course?.title}</span>,
            time: item.lessons[0]?.lessonDate && item.lessons[0]?.startHour ? (
                <span onClick={() => handleClickLessonTime(item.lessons[0]?.lessonDate)} className='text-blue-500 cursor-pointer'>
                    <u>{formatDate(item.lessons[0]?.lessonDate)} - {item.lessons[0]?.startHour}</u>
                </span>
            ) : (
                <span>No hay información</span>
            ), buttons: (
                <div className="d-flex ">
                    <Button type="danger" >
                        <Link to={`/backoffice/editStudent/${item.id && item.id}`}>
                            <EditOutlined />
                        </Link>
                    </Button>
                    <Button type='danger' onClick={() => handleClicMailIcon(item)} className={`d-flex justify-content-center align-items-center `} >
                        <MailOutlined />
                    </Button>
                </div>
            )
        };
    });

    function formatDate(dateString) {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Los meses van de 0 a 11
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    }

    if (loading) {
        return <Spin className='w-100 d-flex justify-content-center' size="large" />;
    }


    const normalizePhoneNumber = (phone) => {
        if (!phone) return '';
        return phone.toString().replace(/\s+|\+/g, '');
    };



    return (
        <div className='flex items-center justify-center'>
            <Input
                type="text"
                placeholder="Buscar..."
                value={searchTerm}
                onChange={handleSearchChange}
            />
            <Table isStriped className='w-full justify-center items-center'>
                <TableHeader>
                    {headersToRender.map((header, index) => (
                        <TableColumn className='bg-gray-500 rounded-full text-white' key={index}>{header.title}</TableColumn>
                    ))}
                </TableHeader>
                <TableBody emptyContent={'No hay información'}>
                    {items.map((client, index) => (
                        <TableRow key={`entity-${index}`} className={`border-b'}`}>
                            {headersToRender.map((header, headerIndex) => (
                                <TableCell key={headerIndex}>{client[header.accessor]}</TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <div className='w-full justify-center items-center bg-green-300'>
                <Pagination
                    total={(currentPage - 1) * pageSize + searchResults.length + (hasMoreResults ? 1 : 0)}
                    showTotal={(total, range) => `${range[0]}-${range[1]} de ${hasMoreResults ? 'más de ' : ''}${total} clientes`}
                    pageSize={pageSize}
                    current={currentPage}
                    onChange={handlePageChange}
                    showSizeChanger={false}
                />
            </div>
            <Modal
                afterClose={() => setEmailToSend('')}
                open={isModalMailVisible}
                onOk={() => handleSendEmail()}
                onCancel={closeMailModal}
                width={1200}
                className='modal-dialog-centered d-flex justify-content-center align-items-center'
            >
                <Input
                    className='m-1 w-100 mx-auto m-4'
                    size='large'
                    placeholder="Ingrese el mail de destino"
                    type='email'
                    name='email'
                    value={emailToSend}
                    onChange={(e) => handleNewMail(e)}
                />
            </Modal>

        </div>
    );
};

export default ClientSearcher;
